import React from 'react';
import { SignupComponent } from '../components/SignupComponent';

const Signup = () => {
	return <SignupComponent />;
};

export default Signup;
